import { fromEnum } from '../utils/from-enum';

/**
 * ViewableAppType are used in the frontend. Currently, the only one that exists
 * determise which oauth providers are associated with a given org.
 */
/** DO NOT CHANGED - USED IN DB. */
export enum ViewableAppType {
  IntegrationConfig = 'IntegrationConfig',
}

export const ViewableAppTypeT = fromEnum(ViewableAppType);
/**
 * These are the backend app types. They are used by platform, and are stored
 * in the app_config table. That table associates orgs with app types,
 * and that association determines what actions that org can take.
 */
/** DO NOT CHANGED - USED IN DB. */
export enum BackendAppType {
  TestReducer = 'TestReducer',
  RlClient = 'RlClient',
  UPSClient = 'UPSClient',
  TwilioVoice = 'TwilioVoice',
}

export const BackendAppTypeT = fromEnum(BackendAppType);

/**
 * All of these app types have a corresponding configuration object
 * associated with them that contains information unique to the org. That
 * mapping is done in the AppTypeConfigMapProps object.
 */
export type AppType = ViewableAppType | BackendAppType;

export const viewableAppTypeNameMap: Record<ViewableAppType, string> = {
  IntegrationConfig: 'Integration Settings',
};
